import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1943a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Заголовок колонки", -1))
const _hoisted_4 = { class: "col-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Буква колонки", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Поле", -1))
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Описание поля", -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Порядок при экспорте", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = {
  key: 0,
  class: "col-6"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Соответствует", -1))
const _hoisted_19 = {
  key: 1,
  class: "col-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog",
    height: '380px',
    onSave: _ctx.save
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Заголовок колонки...",
            "show-clear-button": true,
            hasEmptyValue: false,
            value: model.columnTitle,
            "onUpdate:value": ($event: any) => ((model.columnTitle) = $event),
            validationGroup: validationGroup
          }, null, 8, ["value", "onUpdate:value", "validationGroup"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Буква колонки...",
            "show-clear-button": true,
            hasEmptyValue: true,
            value: model.columnLetter,
            "onUpdate:value": ($event: any) => ((model.columnLetter) = $event)
          }, null, 8, ["value", "onUpdate:value"])
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Поле...",
            "show-clear-button": true,
            hasEmptyValue: false,
            value: model.field,
            "onUpdate:value": ($event: any) => ((model.field) = $event),
            validationGroup: validationGroup
          }, null, 8, ["value", "onUpdate:value", "validationGroup"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Описание поля...",
            hasEmptyValue: false,
            "show-clear-button": true,
            value: model.fieldDescription,
            "onUpdate:value": ($event: any) => ((model.fieldDescription) = $event),
            validationGroup: validationGroup
          }, null, 8, ["value", "onUpdate:value", "validationGroup"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_DxCheckBox, {
            class: "Import-checkbox",
            value: model.isRequired,
            "onUpdate:value": ($event: any) => ((model.isRequired) = $event),
            text: "Обязательна"
          }, null, 8, ["value", "onUpdate:value"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_IntegerControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Порядок при экспорте...",
            hasEmptyValue: true,
            "show-clear-button": true,
            value: model.exportOrder,
            "onUpdate:value": ($event: any) => ((model.exportOrder) = $event),
            validationGroup: validationGroup
          }, null, 8, ["value", "onUpdate:value", "validationGroup"])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (model.isBoolean)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_TextControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Соответствует...",
                hasEmptyValue: !model.isBoolean || model.isBooleanTrueAnyNotEmpty,
                disabled: model.isBooleanTrueAnyNotEmpty,
                "show-clear-button": true,
                value: model.booleanTrueValue,
                "onUpdate:value": ($event: any) => ((model.booleanTrueValue) = $event),
                validationGroup: validationGroup
              }, null, 8, ["hasEmptyValue", "disabled", "value", "onUpdate:value", "validationGroup"])
            ]))
          : _createCommentVNode("", true),
        (model.isBoolean)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_DxCheckBox, {
                class: "Import-checkbox",
                value: model.isBooleanTrueAnyNotEmpty,
                "onUpdate:value": ($event: any) => ((model.isBooleanTrueAnyNotEmpty) = $event),
                onValueChanged: _ctx.onIsBooleanTrueAnyNotEmptyValueChanged,
                text: "Любое не пустое"
              }, null, 8, ["value", "onUpdate:value", "onValueChanged"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onSave"]))
}